import React from "react";
import PropTypes from "prop-types";

import { PageColumn } from "components/ui/PageColumns";
import { ClassInformationEnrollmentCard } from "components/cards/ClassInformationEnrollmentCard";
import { SectionOverviewCard } from "components/cards/SectionOverviewCard";

export default function EnrollmentInfoTab({ currentCourse, currentSemester }) {
  return (
    <PageColumn>
      <SectionOverviewCard course={currentCourse} />
      <ClassInformationEnrollmentCard
        course={currentCourse}
        semester={currentSemester}
      />
    </PageColumn>
  );
}

EnrollmentInfoTab.displayName = "EnrollmentInfoTab";
EnrollmentInfoTab.propTypes = {
  currentCourse: PropTypes.object,
  currentSemester: PropTypes.object,
};
